import appConfig from "../app.config";

var oauthSettings = {
  client_id: appConfig.settings.clientId,
  scope: appConfig.settings.scope,
  authorize_url: appConfig.settings.authorizeUrl,
  token_url: appConfig.settings.tokenUrl,
  logout_url: appConfig.settings.logoutUrl,
  redirect_uri: window.location.origin, //Gets the current
  autologin: true,
  debug: false,
};

/*

An OAUTH Wrapper Sample

    <oauth-wrapper 
        :credentials.sync="credentials"
        :authorizeUrl="authorize_url" 
        :tokenUrl="token_url" 
        :logoutUrl="logout_url" 
        :scope="scope" 
        :client_id="client_id" 
        :redirect_uri="redirect_uri" 
        :loginIncrementor="loginIncrementor"
        :autologin="autologin" :debug="debug">

            <!--- Your Protected Content Here --> 

    </oauth-wrapper>


A Login Button Sample (When autologin is FALSE)

    <v-btn @click="login" color="primary">Start Login Process</v-btn>

*/

/*----------------------------- Be careful below this line -------------------------------*/

import oauthWrapper from "@/_components/security/oauth/oauth-wrapper.vue";
import credentials from "@/_mixins/credentials-mixin";

export default {
  components: { oauthWrapper },
  mixins: [credentials],
  data() {
    return Object.assign({ loginIncrementor: 0 }, oauthSettings);
  },
  computed: {
    isLoggedIn() {

      return !!this.credentials;

    },
    credentials: {
      get() {
        if (this.credentialCacheUID > 0) {
          return this.getCredentials(this.client_id);
        }
        return null;
      },
      set(newVal) {
        if (!!newVal) {
          this.addCredentials(this.client_id, newVal);
        }
      },
    },
  },
  methods: {
    login() {
      this.deleteCredentials(this.client_id);
      this.credentials = null;
      this.$nextTick((e) => {
        this.loginIncrementor++;
      }); //forces the login event on the child component
    },
  },
};
